
























































































































import Vue from 'vue';
import _ from 'lodash';
import moment from 'moment-timezone';

import Requester from '../../requester';
import { periodosMedicoesPressaoArterialItems, posicoesMedicoesPressaoArterialItems } from '../../utils/constants';
import { MedicaoPressaoArterial } from '../../../../back/src/entity/MedicaoPressaoArterial';
import { MedicaoPressaoArterialAlterarFormData, MedicaoPressaoArterialCriarFormData } from '../../../../back/src/types';

export default Vue.extend({
  name: 'MedicaoPressaoArterialForm',
  props: {
    medicaoPressaoArterial: {
      type: Object as () => MedicaoPressaoArterial,
    },
  },
  data() {
    return {
      loading: false,
      periodosItems: periodosMedicoesPressaoArterialItems,
      posicoesItems: posicoesMedicoesPressaoArterialItems,
      menuDataMedicao: false,
      dataMedicaoFormatada: null,
      form: {
        dataMedicao: null,
        max: null,
        min: null,
        periodo: null,
        postura: null,
        observacoes: null,
      },
      rules: {
        required: [
          (v: string) => !!v || 'Campo obrigatório.',
        ],
      },
    };
  },
  mounted() {
    if (this.medicaoPressaoArterial) {
      this.preencheForm();
    }
  },
  computed: {
    pacienteId(): number | null {
      return (this.$store.getters.usuario) ? this.$store.getters.usuario.paciente_id || null : null;
    },
    formMedicaoPressaoArterial(): Vue & {
      validate: () => boolean,
      reset: () => void,
      } {
      return this.$refs.formMedicaoPressaoArterial as Vue & {
        validate: () => boolean,
        reset: () => void,
      };
    },
    dataMedicaoFormatadaComputed(): string {
      if (this.form.dataMedicao) {
        const momentDataMedicao = moment(this.form.dataMedicao);
        if (momentDataMedicao.isValid()) {
          return momentDataMedicao.format('DD/MM/YYYY');
        }
      }
      return '';
    },
  },
  methods: {
    // eslint-disable-next-line func-names
    submitFormDebounce: _.debounce(async function () { await this.submitForm(); }, 200),
    async submitForm() {
      this.loading = true;
      if (!this.formMedicaoPressaoArterial.validate()) {
        this.loading = false;
        return;
      }
      let formData;
      try {
        let response;
        let msg: string;
        let event: string;
        if (this.medicaoPressaoArterial) {
          formData = {
            id: this.medicaoPressaoArterial.id,
            paciente_id: this.pacienteId,
            data_medicao: this.form.dataMedicao,
            periodo: this.form.periodo,
            postura: this.form.postura,
            max: Number(this.form.max),
            min: Number(this.form.min),
            observacoes: this.form.observacoes,
          } as MedicaoPressaoArterialAlterarFormData;
          response = await Requester.medicaoPressaoArterial.alteraMedicao(
            this.medicaoPressaoArterial.id,
            formData,
          );
          msg = 'Dados alterados com sucesso.';
          event = 'medicao-alterada';
        } else {
          formData = {
            paciente_id: this.pacienteId,
            data_medicao: this.form.dataMedicao,
            periodo: this.form.periodo,
            postura: this.form.postura,
            max: Number(this.form.max),
            min: Number(this.form.min),
            observacoes: this.form.observacoes,
          } as MedicaoPressaoArterialCriarFormData;
          response = await Requester.medicaoPressaoArterial.criaMedicao(formData);
          msg = 'Os dados foram salvos';
          event = 'medicao-criada';
        }
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.formMedicaoPressaoArterial.reset();
          this.form.dataMedicao = null;
          this.$emit(event, response.data);
          this.$root.$emit('avisoSnackbar', { color: 'success', text: msg });
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading = false;
      }
    },
    preencheForm() {
      this.form.dataMedicao = moment(this.medicaoPressaoArterial.data_medicao).utc().format('YYYY-MM-DD');
      this.form.max = this.medicaoPressaoArterial.max;
      this.form.min = this.medicaoPressaoArterial.min;
      this.form.periodo = this.medicaoPressaoArterial.periodo;
      this.form.postura = this.medicaoPressaoArterial.postura;
      this.form.observacoes = this.medicaoPressaoArterial.observacoes;
    },
  },
  watch: {
    medicaoPressaoArterial() {
      if (!this.medicaoPressaoArterial) {
        this.formMedicaoPressaoArterial.reset();
        this.form.dataMedicao = null;
      } else {
        this.preencheForm();
      }
    },
    'form.dataMedicao': {
      handler() {
        this.dataMedicaoFormatada = this.dataMedicaoFormatadaComputed;
      },
    },
  },
});
